import React, { useEffect, useState } from "react";
import Dialog from "../../../../components/Dialog/Dialog";
import { withStyles } from "@material-ui/core";
import CloseIcon from "../../../../components/Icon/Close";
import InputForm from "../../../../components/Input/InputForm";
import { Button } from "../../../../components/ui/Buttons";
import { TextFieldSearch } from "../../../../components/TextField";
import { findProcedimentos } from "../../../../services/ProcedimentoService";
import {
  atualizarProcedimentosModalidadeExame,
  findProcedimentosByModalidade,
} from "../../../../services/ExamePacswebService";
import { inject } from "mobx-react";
import { observer } from "mobx-react-lite";

const ModalExameSelecionado = observer(
  ({ classes, open, handleClose, exameSelecionado, exameStore, onSave }) => {

    const [procedimentosSelecionados, setProcedimentosSelecionados] = useState([]);
    const [isLoading, setIsLoading] = useState(false);

    useEffect(() => {
      if (open && exameSelecionado?.codigo) {
        loadExameData();
      }
    }, [open, exameSelecionado?.codigo]);

    const loadExameData = async () => {
      try {
        setIsLoading(true);
        const response = await findProcedimentosByModalidade({
          modeloExameCodigo: exameSelecionado?.codigo,
        });
        if (response && response.length > 0) {
          setProcedimentosSelecionados(response);
        }
      } catch (error) {
        console.error(error);
      } finally {
        setIsLoading(false);
      }
    };

    const loadProcedimentos = async (search, loadedOptions, { page }) => {
      try {
        const response = await findProcedimentos({
          pageableDTO: {
            pageNumber: page,
            pageSize: 10,
            sortDir: "ASC",
            sortField: "nome",
          },
          nome: search,
          ativo: true,
        });

        const { content, last } = response.data.data.findAllProcedimentos;
        return {
          options: content,
          hasMore: !last,
          additional: {
            page: page + 1,
          },
        };
      } catch (error) {
        console.error(error);
      }
    };

    const handleAddProcedimento = (procedimento) => {
      if (!procedimento) return;
      if (procedimentosSelecionados.some((item) => item?.id === procedimento?.id))return;
      
      setProcedimentosSelecionados([
        ...procedimentosSelecionados,
        procedimento,
      ]);
    };

    const handleRemoveProcedimento = (procedimentoId) => {
      setProcedimentosSelecionados(
        procedimentosSelecionados.filter((p) => p.id !== procedimentoId),
      );
    };

    const handleClickSalvar = async () => {
      try {
        setIsLoading(true);
        await atualizarProcedimentosModalidadeExame({
          codigo: exameSelecionado?.codigo,
          procedimentosIds: procedimentosSelecionados.map((p) => p.id),
        });
        exameStore.openNotification(
          "Procedimentos vinculados com sucesso!",
          "success",
        );
        onSave && onSave();
        handleClose();
      } catch (error) {
        exameStore.openNotification("Erro ao salvar!", "error");
      } finally {
        setIsLoading(false);
      }
    };

    const disabled = procedimentosSelecionados.length === 0;
    return (
      <>
        <Dialog
          open={open}
          onClose={handleClose}
          classes={{ paper: classes.dialog }}
        >
          <div className={classes.root}>
            <div className={classes.header}>
              <div className={classes.title}>Exame Selecionado</div>
              <Button onClick={handleClose} shape="circle" bgColor="#FB7676">
                <CloseIcon />
              </Button>
            </div>
            <div className={classes.content}>
              <div className={classes.wrapperInputRow}>
                <div className={classes.wrapperInput}>
                  <label className={classes.label}>Modalidade</label>
                  <InputForm
                    value={exameSelecionado?.descricao}
                    disabled
                    classes={{
                      input: classes.input,
                    }}
                  />
                </div>
                <div className={classes.wrapperInputCodigo}>
                  <label className={classes.label}>Código</label>
                  <InputForm
                    value={exameSelecionado?.codigo}
                    disabled
                    classes={{
                      input: classes.input,
                    }}
                  />
                </div>
              </div>
              <div className={classes.wrapperScroll}>
                <div className={classes.wrapper}>
                  <div className={classes.wrapperInputFilter}>
                    <label className={classes.label}>
                      Selecione os procedimentos
                    </label>
                    <TextFieldSearch
                      placeholder="Selecione"
                      classIcons={classes.classIcons}
                      classInput={classes.reactSelect}
                      classNotched={classes.notchedOutline}
                      loadOptions={loadProcedimentos}
                      getOptionLabel={(option) => option?.nome}
                      getOptionValue={(option) => option?.id}
                      onChange={handleAddProcedimento}
                      withPaginate
                      menuPlacement="auto"
                      isClearable
                      debounceTimeout={300}
                      additional={{
                        page: 0,
                      }}
                    />
                  </div>
                  <div className={classes.examesList}>
                    <label className={classes.label}>
                      Procedimentos Selecionados:
                    </label>
                    <div className={classes.examesItems}>
                      {procedimentosSelecionados.length === 0 ? (
                        <div className={classes.emptyMessage}>
                          Nenhum procedimento selecionado
                        </div>
                      ) : (
                        procedimentosSelecionados.map((procedimento) => (
                          <div
                            key={procedimento.id}
                            className={classes.exameItem}
                          >
                            <span>{procedimento.nome}</span>
                            <div
                              className={classes.removeIcon}
                              onClick={() =>
                                handleRemoveProcedimento(procedimento.id)
                              }
                            >
                              <CloseIcon />
                            </div>
                          </div>
                        ))
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className={classes.wrapperButton}>
              <Button
                onClick={handleClickSalvar}
                disabled={isLoading || disabled}
              >
                Salvar
              </Button>
            </div>
          </div>
        </Dialog>
      </>
    );
  },
);

const styles = {
  dialog: {
    height: "500px",
    width: "700px",
    display: "flex",
    flexDirection: "column",
    overflow: "hidden",
  },
  root: {
    width: "100%",
    height: "100%",
    padding: "10px",
    boxSizing: "border-box",
    display: "flex",
    flexDirection: "column",
  },
  header: {
    flexShrink: 0,
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    padding: "10px",
    borderBottom: "1px solid #e5e5e5",
  },
  title: {
    fontSize: "20px",
    fontWeight: "bold",
  },
  content: {
    flex: 1,
    display: "flex",
    flexDirection: "column",
    overflow: "hidden",
    gap: "10px",
  },
  wrapperInputRow: {
    display: "flex",
    gap: "10px",
    padding: "10px",
  },
  wrapperInput: {
    display: "flex",
    flexDirection: "column",
    boxSizing: "border-box",
    flex: 1,
  },
  wrapperInputCodigo: {
    display: "flex",
    flexDirection: "column",
    boxSizing: "border-box",
    width: "150px",
  },
  input: {
    width: "100%",
    color: "#505050",
    background: "#F2F2F2",
    border: "0 !important",
    borderRadius: "8px",
    height: "30px",
    boxSizing: "border-box",
    fontSize: "14px",
  },
  label: {
    color: "#505050",
    fontSize: "12px",
  },
  wrapper: {
    padding: "10px",
    gap: "5px",
    display: "flex",
    flexDirection: "column",
    flex: 1,
    minHeight: 0,
  },
  wrapperScroll: {
    flex: 1,
    minHeight: 0,
    borderRadius: "8px",
    display: "flex",
    flexDirection: "column",
    overflow: "hidden",
  },
  wrapperButton: {
    flexShrink: 0,
    display: "flex",
    justifyContent: "flex-end",
    width: "100%",
    paddingTop: "10px",
  },
  wrapperInputFilter: {
    width: "100%",
    display: "flex",
    boxSizing: "border-box",
    flexDirection: "column",
    padding: "10px",
    background: "#f2f2f2",
    borderRadius: "8px",
  },
  classIcons: {
    fontSize: 24,
    padding: "0px",
  },
  notchedOutline: {
    border: "0",
  },
  reactSelect: {
    width: "97%",
    background: "#FFF",
  },
  wrapperProcedimentos: {
    gap: "5px",
    display: "flex",
    flexDirection: "column",
    padding: "15px",
    background: "#f2f2f2",
    borderRadius: "8px",
    height: "300px",
    width: "100%",
  },
  contentProcedimento: {
    gap: "10px",
    display: "flex",
    background: "#fff",
    width: "100%",
    padding: "9px",
    borderRadius: "8px",
    alignItems: "center",
    justifyContent: "space-between",
    boxSizing: "border-box",
  },
  headerProcedimento: {
    display: "flex",
    justifyContent: "space-between",
    padding: "5px",
    fontSize: "12px",
    color: "#505050",
  },
  scrollProcedimentos: {
    gap: "10px",
    height: "100%",
    display: "flex",
    overflowY: "scroll",
    flexDirection: "column",
  },
  loading: {
    height: "100%",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
  },
  icon: {
    flexShrink: 0,
    cursor: "pointer",
  },
  examesList: {
    display: "flex",
    flexDirection: "column",
    gap: "8px",
    minHeight: "170px",
  },
  examesItems: {
    display: "flex",
    flexDirection: "column",
    gap: "8px",
    height: "150px",
    overflowY: "auto",
    padding: "8px",
    background: "#fafafa",
    borderRadius: "8px",
    border: "1px solid #e0e0e0",
  },
  emptyMessage: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    height: "100%",
    color: "#868686",
    fontSize: "14px",
    fontStyle: "italic",
  },
  exameItem: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    padding: "10px 14px",
    background: "#fff",
    borderRadius: "6px",
    fontSize: "14px",
    border: "1px solid #e0e0e0",
    transition: "all 0.2s ease",
    "&:hover": {
      boxShadow: "0 2px 4px rgba(0,0,0,0.08)",
      borderColor: "#d0d0d0",
    },
    "& span": {
      color: "#505050",
      fontWeight: 500,
    },
  },
  removeIcon: {
    cursor: "pointer",
    fontSize: "22px",
    fontWeight: "bold",
    color: "#868686",
    width: "24px",
    height: "24px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    borderRadius: "50%",
    transition: "all 0.2s ease",
    "&:hover": {
      color: "#fff",
      background: "#726e6e",
    },
  },
};

const stores = ["exameStore"];
const ModalExameSelecionadoWithStyles = withStyles(styles)(
  ModalExameSelecionado,
);
export default inject(stores)(ModalExameSelecionadoWithStyles);
